import { AlertTriangle, Undo2, Check, ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LABELS = { challenge_rules: 'Challenge rules', profit_target: 'Profit target', drawdown: 'Drawdown', payout_split: 'Payout split', payout_schedule: 'Payout schedule' };

export const PropFirmAlerts = ({ alerts = [], authHeader, onKnowledge }) => {
  const open = alerts.filter((a) => !a.dismissed);
  if (!open.length) return null;
  const act = async (id, action) => {
    const res = await fetch(`${API_URL}/api/admin/support/prop-alerts/${id}/${action}`, { method: 'POST', headers: authHeader });
    if (res.ok) onKnowledge(await res.json());
  };
  return (
    <div className="rounded-xl border border-[#F59E0B]/30 bg-[#F59E0B]/5 p-4 space-y-3" data-testid="prop-firm-alerts">
      <h3 className="text-[#F59E0B] font-semibold flex items-center gap-2"><AlertTriangle size={16} /> Prop firm rules changed ({open.length})</h3>
      <p className="text-white/50 text-xs">A live check found rules that differ from your saved data. The firm entry was updated automatically. Undo if it looks wrong.</p>
      {open.map((a) => (
        <div key={a.id} className="rounded-lg bg-black/20 p-3 space-y-2" data-testid={`prop-alert-${a.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="text-white text-sm font-medium">{a.firm} <span className="text-white/40 text-xs ml-1">{new Date(a.at).toLocaleString()} · "{a.question}"</span></p>
            <div className="flex items-center gap-2">
              {a.source && <a href={a.source} target="_blank" rel="noopener noreferrer" className="text-[#a78bfa] text-xs flex items-center gap-1" data-testid={`prop-alert-source-${a.id}`}><ExternalLink size={12} /> Source</a>}
              <button type="button" onClick={() => act(a.id, 'undo')} className="px-2.5 py-1 rounded-full text-xs bg-white/10 text-white/70 flex items-center gap-1" data-testid={`prop-alert-undo-${a.id}`}><Undo2 size={12} /> Undo</button>
              <button type="button" onClick={() => act(a.id, 'dismiss')} className="px-2.5 py-1 rounded-full text-xs bg-[#10B981]/20 text-[#10B981] flex items-center gap-1" data-testid={`prop-alert-keep-${a.id}`}><Check size={12} /> Keep update</button>
            </div>
          </div>
          {a.changes.map((c) => (
            <div key={c.field} className="text-xs grid md:grid-cols-2 gap-2">
              <p className="text-white/40"><span className="text-white/60">{LABELS[c.field] || c.field}, before:</span> {c.old || '(empty)'}</p>
              <p className="text-white/80"><span className="text-[#10B981]">Now:</span> {c.new}{c.reason ? <span className="text-white/40"> ({c.reason})</span> : null}</p>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
